import { render, staticRenderFns } from "./RendererLayout.vue?vue&type=template&id=24a16492"
import script from "./RendererLayout.vue?vue&type=script&lang=js"
export * from "./RendererLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports